module.exports = __webpack_public_path__ + "static/media/login.6c477620.jpg";